export default __webpack_public_path__ + "static/media/bjsh-large.5216fa95.jpg";